/**
 * Tables Routes
 */
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Route, RouteChildrenProps, Switch} from 'react-router-dom';
// async components
import {
    AsyncRulesConfigCreateComponent,
    AsyncRulesConfigEditComponent,
    AsyncRulesConfigListComponent,
} from '../components/AsyncComponent/AsyncComponent';
import {useTranslation} from 'react-i18next';
import {config} from '../config';

const RulesConfig: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('configs.rules_config.name')}`}</title>
                <meta name="description" content="Export Config"/>
            </Helmet>
            <Switch>
                <Route
                    exact
                    path={`${match?.url}`}
                    component={AsyncRulesConfigListComponent}
                />
                <Route
                    exact
                    path={`${match?.url}/:id([0-9]+)`}
                    component={AsyncRulesConfigEditComponent}
                />
                <Route
                    exact
                    path={`${match?.url}/create`}
                    component={AsyncRulesConfigCreateComponent}
                />
                <Redirect
                    exact
                    from={`${match?.url}/`}
                    to={`${match?.url}`}
                />
            </Switch>
        </div>
    );
};

export default RulesConfig;
